import http from '@/helpers/Http';

export default {
    namespaced: true,
    state: {
        items: {
            data: [],
            meta: {},
            links: {},
            permissions: [],
        }
    },
    getters: {
        items: state => state.items,
    },
    mutations: {
        setItems(state, items) {
            state.items = items;
        },
    },
    actions: {
        async index({ commit, rootState }) {
            const response = await http.get('admin/roles', {params: rootState.route.query});

            commit('setItems', response.data);

            return response;
        },
        async store({ commit }, payload) {
            const response = await http.post('admin/roles', payload);

            return response;
        },
        async update({ commit }, payload) {
            const response = await http.patch(`admin/roles/${payload.id}`, payload);

            return response;
        },
        async delete({ commit }, id) {
            const response = await http.delete(`admin/roles/${id}`);

            return response;
        }
    }
}